// extracted by mini-css-extract-plugin
export default {"InsalesShow":"styles_InsalesShow__ZZBEs","CardContent":"styles_CardContent__ax7TQ","DialogInsales":"styles_DialogInsales__qpW1p"};